import React from 'react';

import PrimaryButton from '@modules/common/components/buttons/PrimaryButton';
import BaseModal from '@modules/common/components/BaseModal';

import { OAuthClientDescriptor } from '../../../components/types/oauth-client';
import EditClientForm from './EditClientForm';

type Props = {
  client: OAuthClientDescriptor;
  onClientUpdated: () => void;
};

function EditClient({ client, onClientUpdated }: Props) {
  return (
    <BaseModal
      trigger={handleOpen => (
        <PrimaryButton
          type="submit"
          icon="edit"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            handleOpen();
          }}
        />
      )}
    >
      {handleClose => (
        <EditClientForm
          client={client}
          onClientUpdated={onClientUpdated}
          handleClose={handleClose}
        />
      )}
    </BaseModal>
  );
}

export default EditClient;
